import { ReactComponent as Csv_svg } from "../assets/csv.svg";
import { ReactComponent as Pdf_svg } from "../assets/pdf.svg";
import { ReactComponent as Newo4j_svg } from "../assets/neo4j.svg";
import { ReactComponent as Db_svg } from "../assets/sql.svg";
import { ReactComponent as Image_svg } from "../assets/image.svg";
import { ReactComponent as Chat_svg } from "../assets/chatbot.svg";
import { ReactComponent as Youtube_svg } from "../assets/youtube.svg";
import { ReactComponent as Collection_svg } from "../assets/collection.svg";
import { ReactComponent as Prompt_svg } from "../assets/prompt.svg";
import { ReactComponent as ImageGenerator_svg } from "../assets/image_generator.svg";
import { ReactComponent as Globe_Search_svg } from "../assets/globe_search.svg";

import {
  ADD_IMAGES,
  CHAT_DEFAULT,
  CHAT_WITH_EXCEL,
  CHAT_WITH_IMAGE,
  CHAT_WITH_MULTIPLE_SOURCES,
  CHAT_WITH_NEO4J,
  CHAT_WITH_RAG,
  CHAT_WITH_SQL,
  CHAT_WITH_VIDEO,
  CREATE_INDEX,
  DELETE_EXCEL,
  DELETE_IMAGE,
  DELETE_INDEX,
  DELETE_NEO4J_DB,
  DELETE_SQL_CONFIG,
  DELETE_USER_FOLDER,
  DELETE_YT_VIDEOS,
  GENERATE_PROMPT,
  GET_EXCEL,
  GET_EXCEL_DATA,
  GET_IMAGES,
  GET_INDEXES,
  GET_NEO4J_DB_NAMES,
  GET_SQL_DATA,
  GET_SQL_USERS,
  GET_USER_FOLDERS,
  GET_YT_VIDEOS,
  LOADING_SQL_DB,
  LOAD_EXCEL,
  UPLOAD_EXCEL,
  UPLOAD_NEO4J_CONFIG,
  UPLOAD_SQL_CONFIG,
  UPLOAD_YOUTUBE_URL,
  // CHAT_WITH_IMAGE_GENERATOR,
} from "../endpoint";

import {
  COLLECTION,
  DATABASE,
  EXCEL,
  IMAGE,
  NEO4J,
  PDF,
  PROMPT,
  VANILLA,
  YOUTUBE,
  WEB,
  // IMAGE_GENERATOR,
} from "./constants";

import {
  FILE_TYPES_EXCEL,
  FILE_TYPES_JSON,
  FILE_TYPES_PDF,
  FILE_TYPE_IMAGE,
} from "./allowedFileUploadTypes";
const data = [
  {
    name: WEB,
    icon: Globe_Search_svg,
    color: "#F8991C",
    showSecondary: true,
    chaturl: CHAT_DEFAULT,
    prompt_storage: "web",
    geturl: "",
    disabled: false,
    shortname: "WEB",
    datapreviewurl: "",
    mode: ["chat"],
  },
  {
    name: VANILLA,
    icon: Chat_svg,
    color: "#F8991C",
    showSecondary: true,
    chaturl: CHAT_DEFAULT,
    prompt_storage: "default",
    geturl: "",
    disabled: false,
    shortname: "GPT",
    datapreviewurl: "",
    mode: ["chat"],
  },
  {
    name: PDF,
    icon: Pdf_svg,
    loadurl: CREATE_INDEX,
    chaturl: CHAT_WITH_RAG,
    geturl: GET_INDEXES,
    color: "#F8991C",
    showSecondary: true,
    prompt_storage: "rag",
    uploadtypes: FILE_TYPES_PDF,
    deleteurl: DELETE_INDEX,
    disabled: false,
    shortname: "DOCS GPT",
    datapreviewurl: "",
    mode: ["chat"],
  },

  {
    name: IMAGE,
    icon: Image_svg,
    color: "#F8991C",
    showSecondary: false,
    loadurl: ADD_IMAGES,
    chaturl: CHAT_WITH_IMAGE,
    uploadtypes: FILE_TYPE_IMAGE,
    geturl: GET_IMAGES,
    prompt_storage: "image",
    deleteurl: DELETE_IMAGE,
    disabled: false,
    shortname: "image",
    datapreviewurl: "",
    mode: ["image", "multimodal"],
  },
  // {
  //   name: EXCEL,
  //   icon: Csv_svg,
  //   color: "rgb(52, 156, 66)",
  //   showSecondary: false,
  //   disabled: process.env?.REACT_APP_SQL_BASE_URL ? false : true,
  //   loadurl: UPLOAD_EXCEL,
  //   chaturl: CHAT_WITH_EXCEL,
  //   geturl: GET_EXCEL,
  //   prompt_storage: "csv",
  //   uploadtypes: FILE_TYPES_EXCEL,
  //   deleteurl: DELETE_EXCEL,
  //   loaddb: LOAD_EXCEL,
  //   shortname: "excel",
  //   datapreviewurl: GET_EXCEL_DATA,
  //   mode: ["multimodal"],
  // },

  {
    name: COLLECTION,
    icon: Collection_svg,
    color: "#F8991C",
    showSecondary: false,
    disabled: false,
    shortname: "collection",
    chaturl: CHAT_WITH_MULTIPLE_SOURCES,
    geturl: GET_USER_FOLDERS,
    prompt_storage: "multiple",
    uploadtypes: FILE_TYPES_JSON,
    deleteurl: DELETE_USER_FOLDER,
    loadurl: UPLOAD_NEO4J_CONFIG,
    datapreviewurl: "",
    mode: ["multimodal"],
  },
  // {
  //   name: IMAGE_GENERATOR,
  //   icon: ImageGenerator_svg,
  //   color: "#F8991C",
  //   showSecondary: false,
  //   loadurl: ADD_IMAGES,
  //   chaturl: CHAT_WITH_IMAGE_GENERATOR,
  //   uploadtypes: FILE_TYPE_IMAGE,
  //   geturl: "",
  //   prompt_storage: "",
  //   deleteurl: "",
  //   disabled: false,
  //   // shortname: "Image_Generator",
  //   shortname: "Image Gen",
  //   datapreviewurl: "",
  //   mode: ["image_generation"],
  // },
];

export default data;
